import API from "../../../../../global/api";


export const requestAddFBRBuyer = () => {
    return {
        type: "REQUEST_ADD_FBR_BUYER",
    };
};
export const successAddFBRBuyer = (data) => {
    return {
        type: "SUCCESS_ADD_FBR_BUYER",
        payload: data,
    };
};
export const errorAddFBRBuyer = () => {
    return {
        type: "ERROR_ADD_FBR_BUYER",
    };
};
export const AddFBRBuyerApi = (data, showSuccessAlert, showErrorAlert) => {
    return (dispatch) => {
        dispatch(requestAddFBRBuyer());
        API.post(`/FBRInvoice/add-buyer`, data).then((res) => {
            dispatch(successAddFBRBuyer(data));
            showSuccessAlert(res.data.message);
        }).catch((error) => {
            dispatch(errorAddFBRBuyer());
            showErrorAlert(error.response.data.message || "Something went wrong");
        })
    };
};


export const requestGetFBRBuyer = () => {
    return {
        type: "REQUEST_GET_FBR_BUYER",
    };
};
export const successGetFBRBuyer = (data) => {
    return {
        type: "SUCCESS_GET_FBR_BUYER",
        payload: data,
    };
};
export const errorGetFBRBuyer = () => {
    return {
        type: "ERROR_GET_FBR_BUYER",
    };
};
export const GetFBRBuyerApi = () => {
    return (dispatch) => {
        dispatch(requestGetFBRBuyer());
        API.get(`/FBRInvoice/get-buyers?page=0&limit=1000`).then((res) => {
            let getData = res.data;
            dispatch(successGetFBRBuyer(getData));
        }).catch((error) => {
            dispatch(errorGetFBRBuyer());
        })
    };
};


export const DeleteRequestFBRBuyer = () => {
    return {
        type: "DELETE_REQUEST_FBR_BUYER",
    };
};
export const DeleteSuccessFBRBuyer = (buyerId) => {
    return {
        type: "DELETE_SUCCESS_FBR_BUYER",
        buyerId: buyerId,
    };
};
export const DeleteErrorFBRBuyer = () => {
    return {
        type: "DELETE_ERROR_FBR_BUYER",
    };
};
export const DeleteFBRBuyerApi = (buyerId) => {
    return dispatch => {
        dispatch(DeleteRequestFBRBuyer());
        API.delete(`/FBRInvoice/delete-buyer/${buyerId}`).then(res => {
            dispatch(DeleteSuccessFBRBuyer(buyerId))
        }).catch((error) => {
            dispatch(DeleteErrorFBRBuyer())
        });
    }
};